"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var UPDATE_JOB_PROGRESS_INTERVAL = 500;
var UPDATE_JOB_PROGRESS_MAX_ATTEMPTS = 5;
var OrgEntitlementsExporter = /*#__PURE__*/function () {
  OrgEntitlementsExporter.$inject = ["$scope", "$interval", "modalService", "entitlementsService", "taskQueueService", "ENTITLEMENTS_SERVICE_ENDPOINT"];
  /* @ngInject */
  function OrgEntitlementsExporter($scope, $interval, modalService, entitlementsService, taskQueueService, ENTITLEMENTS_SERVICE_ENDPOINT) {
    _classCallCheck(this, OrgEntitlementsExporter);
    this.$scope = $scope;
    this.$interval = $interval;
    this.modalService = modalService;
    this.entitlementsService = entitlementsService;
    this.taskQueueService = taskQueueService;
    this.entitlementsEndpoint = ENTITLEMENTS_SERVICE_ENDPOINT;
  }
  _createClass(OrgEntitlementsExporter, [{
    key: "$onInit",
    value: function $onInit() {
      this.loading = false;
      this.jobDocCreated = false;
      this.jobId = null;
      this.jobProgress = 0;
      this.gettingJobProgressFailed = false;
    }

    /**
     * Creates a backgroundjob for the exporter type, and
     * displays a modal showing the progress with a download button when job has finished.
     *
     */
  }, {
    key: "createExport",
    value: function createExport() {
      var _this = this;
      this.loading = true;
      this.modalService.openModal({
        templateUrl: '/src/angular/components/orgs/view-org/org-entitlements-manager/org-entitlements-exporter/org-entitlements-exporter-modal.html',
        scope: {
          vm: this
        }
      });
      this.entitlementsService.createEventEntitlementsExportJob(this.type, this.organisation._id).then(function (response) {
        _this.jobDocCreated = true;
        _this.jobId = response.jobId;
        _this.periodicallyUpdateJobProgress(response.jobId);
      }).catch(function (err) {
        _this.jobDocCreated = false;
        console.error('[OrgEntitlementExporter]', 'Error occured', err);
      }).finally(function () {
        _this.loading = false;
      });
    }

    /**
     * Checks the status of the job every UPDATE_JOB_PROGRESS_INTERVAL ms, and
     * updates this.jobProgess accordingly.
     *
     */
  }, {
    key: "periodicallyUpdateJobProgress",
    value: function periodicallyUpdateJobProgress(jobId) {
      var _this2 = this;
      var updateJobProgressAttempts = 0;
      this.jobProgressInterval = this.$interval(function () {
        _this2.taskQueueService.getJobStatus(jobId).then(function (response) {
          _this2.jobProgress = response.progress;
          if (_this2.jobProgress === 100) _this2.$interval.cancel(_this2.jobProgressInterval);
        }).catch(function (err) {
          updateJobProgressAttempts += 1;
          if (updateJobProgressAttempts >= UPDATE_JOB_PROGRESS_MAX_ATTEMPTS) {
            _this2.$interval.cancel(_this2.jobProgressInterval);
            _this2.gettingJobProgressFailed = true;
            console.error('[OrgEntitlementExporter]', 'Error occured', err);
          }
        });
      }, UPDATE_JOB_PROGRESS_INTERVAL);
    }

    /**
     * Returns the link for the exportec excel file for this.type and this.jobId
     *
     */
  }, {
    key: "getDownloadLink",
    value: function getDownloadLink() {
      return "".concat(this.entitlementsEndpoint, "/").concat(this.organisation._id, "/").concat(this.type, ".xlsx/").concat(this.jobId);
    }
  }]);
  return OrgEntitlementsExporter;
}();
module.exports = angular.module('backstage.components.orgs.view-org.entitlements-manager.org-entitlements-exporter', ['backstage.services']).component('bsOrgEntitlementsExporter', {
  template: '<button class="btn btn-primary" ng-click="vm.createExport()">Export XLS</button>',
  bindings: {
    organisation: '<',
    type: '@'
  },
  controllerAs: 'vm',
  controller: OrgEntitlementsExporter
}).name;